import React from 'react'
import styled from 'styled-components'
import Icons from '../../components/Icons'
import {formatTime, formatDate} from '../../utils/time'

const BookingListItem = props => {
  const {updateMeeting, item} = props

  const onDelete = () => {
    updateMeeting(item)
  }

  const {date, start, end, resId} = item

  return (
    <StyledItem>
      <StyledDateContainer>
        <StyledDay>{formatDate(date, 'D')}</StyledDay>
        <StyledYear>
          <MonthName>{formatDate(date, 'MMMM, YYYY')}</MonthName>
          <DayName>{formatDate(date, 'ddd')}</DayName>
        </StyledYear>
      </StyledDateContainer>
      <StyledTime>
        <div>
          {formatTime(start, 'LT')} - {formatTime(end, 'LT')}
        </div>
      </StyledTime>

      {resId > 0 && (
        <DeleteIcon onClick={onDelete}>
          <Icons icon={'DELETE_BOOKING'} />
        </DeleteIcon>
      )}
    </StyledItem>
  )
}

export default BookingListItem

const StyledItem = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  margin: 8px 0 8px 0;
`

const StyledDateContainer = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
`

const StyledText = styled.div`
  font-weight: 600;
  letter-spacing: -0.5px;
  color: #000000;
`

const StyledDay = styled(StyledText)`
  padding-left: 20px;
  font-size: 42px;
`

const StyledYear = styled(StyledText)`
  padding-left: 10px;
`

const MonthName = styled(StyledText)`
  color: #191919;
  font-size: 12px;
`

const DayName = styled(StyledText)`
  color: #a4a9b7;
  font-size: 12px;
`

const StyledTime = styled(StyledText)`
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  box-sizing: border-box;
  margin-left: auto;
  padding-right: 20px;
`

const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: 20px;
`
